import React from 'react';
import {Tooltip} from 'antd';
import {Location} from '@reach/router';
import {Control, GeoSearch, CustomMarker} from 'react-instantsearch-dom-maps';
import {goToProject} from '../../modules/utils';
import styled from 'styled-components';
import ErrorBoundary from '../ErrorBoundary';
import GoogleMapsApiLoader from '../map/GoogleMapsApiLoader';
import {API_KEY_GOOGLE_MAPS} from '../../constants/';

const iconMarker = require('../../sources/images/cc_mapmarker.png');

const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  & .ais-GeoSearch,
  & .ais-GeoSearch-map {
    height: 100%;
  }

  & .ais-GeoSearch-control {
    display: none !important;
  }
`;

const Marker = styled(CustomMarker)`
  cursor: pointer !important;
`;

const AgGoogleMaps = () => {
  return (
    <Location>
      {({location}) => (
        <Wrapper className="h-100">
          <ErrorBoundary key={location.pathname}>
            <GoogleMapsApiLoader apiKey={API_KEY_GOOGLE_MAPS}>
              {google => (
                <GeoSearch google={google}>
                  {({hits}) => (
                    <div>
                      <Control />
                      {hits.map(hit => (
                        <Marker
                          className="my-marker"
                          key={hit.objectID}
                          hit={hit}
                          onClick={() => {
                            goToProject(hit.title_slug, hit);
                          }}>
                          <Tooltip
                            className="my-tooltip"
                            placement="top"
                            title={hit.name}>
                            <img src={iconMarker} width={20} height={30} alt="" />
                          </Tooltip>
                        </Marker>
                      ))}
                    </div>
                  )}
                </GeoSearch>
              )}
            </GoogleMapsApiLoader>
          </ErrorBoundary>
        </Wrapper>
      )}
    </Location>
  );
};

export default AgGoogleMaps;
